module.exports = new __parcel__URL__("AudioPanelErrorIllustrationDark.fd4f5286.svg").toString();